import {Modal, Text, Textarea} from '@mantine/core';
import {ERROR_MESSAGES} from '../../../../constants/errorMessages';
import {MAX_TEXT_INPUT_LENGTH} from '../../../../constants/inputLimits';
import {Z_INDEX} from '../../../../constants/zIndex';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';

type TextImportModalProps = {
  opened: boolean;
  onClose: () => void;
  onSubmit: () => void;
  text: string;
  onChange: (text: string) => void;
  isLoading?: boolean;
};

export const TextImportModal: React.FC<TextImportModalProps> = ({
  opened,
  onClose,
  onSubmit,
  text,
  onChange,
  isLoading = false,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      radius={16}
      centered
      size="md"
      title="自由入力テキストからAI自動入力"
      zIndex={Z_INDEX.MODAL}
      styles={{
        title: {
          fontWeight: 'bold',
        },
      }}
    >
      <div className="flex flex-col gap-24">
        <div className="flex flex-col gap-16">
          <Textarea
            placeholder="選考情報をテキストで入力してください"
            value={text}
            onChange={(event) => onChange(event.currentTarget.value)}
            minRows={8}
            autosize
            styles={{
              input: {
                borderRadius: '12px',
              },
            }}
          />
          {text.length > MAX_TEXT_INPUT_LENGTH && (
            <Text className="text-notification-1" size="sm">
              {ERROR_MESSAGES.TEXT_LENGTH_LIMIT_EXCEEDED}
            </Text>
          )}
        </div>

        <div className="flex items-center justify-center gap-16">
          <ModalCancelButton onClick={onClose}>キャンセル</ModalCancelButton>
          <ModalSubmitButton
            onClick={onSubmit}
            disabled={!text.trim() || text.length > MAX_TEXT_INPUT_LENGTH}
            isLoading={isLoading}
          >
            テキストから抽出
          </ModalSubmitButton>
        </div>
      </div>
    </Modal>
  );
};
